const productSelectionCheckbox = document.querySelectorAll(
  ".product-selection-group input[type='checkbox']",
);
const excludeOtherCoveragesToggle = Array.from(productSelectionCheckbox).filter(
  (element) => element.id !== "recommended-products",
);

if (productSelectionCheckbox) {
  excludeOtherCoveragesToggle.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        checkbox.closest(".control-block").classList.add("--is-checked");
      } else {
        checkbox.closest(".control-block").classList.remove("--is-checked");
      }
    });
  });
}
